import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Strah in trepet",
  "description": "",
  "published": "2006-11-19T00:00:00.000Z",
  "redirect_from": ["/blog/strah-in-trepet/swizec/353"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/includes/editor_upload/Image/kscan_0001.png",
        "alt": "Fear and Loathing platnica",
        "title": "Fear and Loathing platnica"
      }}></img></p>
    <p>{`V petek me je moja najljubsa knjigarna obvestila, da je bila moja kopija knjige `}<em parentName="p">{`Fear and Loathing in Las Vegas`}</em>{` prispela in jo lahko pridem iskat, ko se mi pac zljubi. Razlog, da sem knjigo sploh narocil, lezi v dejstvu, da je film po istem naslovu, v katerem igra Depp, eden najboljsih filmov, kar sem jih kdaj videl.`}</p>
    <p>{`Ko sem knjigo koncno prejel, me je zanimiva naslovnica takoj zvabila v svoje mreze in se zdaj ne vem kdo je pravzaprav na njej upodobljen, Depp ali zares Thompson, ampak saj to v bistvu niti ni vazno. Knjiga je bila, po resnici povedano, tako zelo dobra, da sem jo se isti petek prebral od platnice do platnice in uzival v vsakem trenutku. Edina stvar, ki se mi je zdela malce nenavadna je, da ni knjiga nic drugacna od filma in je film celo zelo odlicna interpretacija le-te. Seveda so z lahkoto opazni manjsi spremenjeni detajli, kak dialog narejen bolj zanimiv oz. gostobeseden in naracija malo manj dolgovezna, ker se dogajanje pac vidi. Kar se pa tice tistega duha in ideje knjige pa ne more nihce ugovarjati.`}</p>
    <p>{`Torej, kot povzetek, knjiga je odlicna in branje priporocam vsakomur.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      